
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';
import { filter } from 'rxjs';
interface chartobject {
  title: string;
  count: number;
  filteration: number;
  xternalurl: string;
}


@Component({
  selector: 'app-home-tab',
  templateUrl: './home-tab.component.html',
  styleUrls: ['./home-tab.component.scss']
})


export class HomeTabComponent implements OnInit {
  selectedElement: any = null;
  sessiondata: any = []
  data: any;
  previousparent: any = []
  identifier: number = 0
  previous: number = 0
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang: any;
  loading: boolean = true
  chartobject: { title: string; count: number }
  invoices: chartobject[] = [];
  branshinvoice: chartobject[] = [];
  incomebranshinvoice: chartobject[] = [];
  storeStatics: chartobject[] = [];
  Notification: [];
  isnewtab: boolean

  searchitems: boolean = false

  loaditems: boolean = false
selectedBreadcrumb:number=0


  not: any

  cdcstatics: any
  datanavgiation: any
  @ViewChild('tabPanel', { static: false }) tabPanel: any;
  constructor(public gt: genericCustomStoreService, private cdRef: ChangeDetectorRef, private publicSettingService: publicSettingService, public router: Router, private cdr: ChangeDetectorRef) {
    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );
    this.gt.checkIsNewTab().subscribe((result: boolean) => {
      this.isnewtab = result;
      console.log("Is new tab:", this.isnewtab);
    });

    this.gt.$home.subscribe(res => {
      this.previousparent = res
    })
  }

  selectedTabIndex = 0;
  tabs = [
     { title: 'الرئيسية', content: 'الرئيسية' },
     { title: 'الاحصائيات', content: 'الاحصائيات' },  
     { title: 'الاشعارات', content: 'الاشعارات' },     
    { title: 'البحث عن الاصناف', content: 'البحث عن الاصناف' },
    { title: 'احصائيات cdc', content: 'احصائيات cdc' }
  ];

  ngOnInit() {
    

    const sessiondata = sessionStorage.getItem("data") as string;
    const firstdata = JSON.parse(sessiondata);
    const data = firstdata?.navihationMenu
    this.not = data.find((x: any) => x.nameEn === "Notification");
    this.cdRef.detectChanges();
    this.cdcstatics = data.find((x: any) => x.controllerName === "CDCStatistics");
    var items = data.find((x: any) => x.nameEn === "Items");
    this.searchitems = items?.permissionActions?.some((action: any) => action.name === "Search") ?? false;
    {


    }

    if (this.not != undefined) {
      if (this.selectedTabIndex === 1 || this.selectedTabIndex === 2) {
        this.getAllCycleCount()
        this.getAllCycleCountQuery()
        this.getSatiscticsForsalesInvoice()
        this.getStatisticsForPurchaseInvoice()

      }


    }

    //  this.loadDataForTab(0);
    this.getMainMenuData()
    if (this.cdcstatics != undefined) {
      this.gt.getcdcsetting().subscribe((res: any) => {
        localStorage.setItem('cdcSetting', JSON.stringify(res));

      });
    }

    // this.getsetting();
    this.GetTreeData()

    this.getsetting();
  }

  isSearchSerialsDependonBranch: boolean = true;
  isTotalSerialsDependonBranch: boolean = true;
  showSendMailButtonInReports: boolean = true;

  showNotifications: boolean = true;
  showSearchItems: boolean = true;
  showStatiscs: boolean = true;
  isCdc: boolean = true;
  getsetting() {

    this.gt.dropdown('Settings/GetDropDown').subscribe((res: any) => {

      if (res != null || res != undefined) {
        this.isSearchSerialsDependonBranch = res.isSearchSerialsDependonBranch;
        this.isTotalSerialsDependonBranch = res.isTotalSerialsDependonBranch;
        this.showSendMailButtonInReports = res.showSendMailButtonInReports;

        this.showNotifications = res.showNotifications;
        this.showSearchItems = res.showSearchItems;
        this.isCdc = res.isCdc;
        this.showStatiscs = res.showStatiscs;
        this.onTabClick(res.mainpage);
      }
      else {
        this.onTabClick(0);
      }

    })


  }
  
  onTabClick(index: number) {
    const totalTabs = this.tabPanel?.items?.length ?? 0;

    debugger
    // If the requested index is out of range, fallback to previous index
    if (index >= totalTabs) {
      console.warn(`Index ${index} out of bounds. Max is ${totalTabs - 1}. Reverting to ${index - 1}`);
      this.selectedTabIndex = totalTabs > 0 ? totalTabs - 1 : 0;
    } else {
      this.selectedTabIndex = index;
    }
    if (this.not != undefined) {
      if (this.selectedTabIndex === 1 || this.selectedTabIndex === 2) {
        this.getAllCycleCount()
        this.getAllCycleCountQuery()
        this.getSatiscticsForsalesInvoice()
        this.getStatisticsForPurchaseInvoice()

      }
      var t = this.searchitems;
      if (this.selectedTabIndex === 3) {

        this.loaditems = true;
      }
      else {

        this.loaditems = false;
      }


    }

  }

  // loadDataForTab(index: number) {
  //   console.log('Executing switch for tab index:', index);
  //   switch (index) {
  //     case 0:
  //       this.getMainMenuData();
  //       break;
  //     case 1:
  //       this.getSatiscticsForsalesInvoice(), this.getStatisticsForPurchaseInvoice(), this.getAllCycleCount();
  //       break;
  //     case 2:this.getAllCycleCount(), this.getAllCycleCountQuery();
  //       break;
  //     default:
  //       break;
  //   }
  // }

  getSatiscticsForsalesInvoice() {
    this.gt.dropdown('CyclesStatiscs/SalesInvoicesForBranchesCount').subscribe((res: any) => {
      this.branshinvoice = res;
      // console.log("this.branshinvoice", this.branshinvoice)
      this.cdr.detectChanges();
    });
  }

  getStatisticsForPurchaseInvoice() {
    this.gt.dropdown('CyclesStatiscs/PurchasesInvoicesForBranchesCount').subscribe((res: any) => {
      this.incomebranshinvoice = res;
      // console.log("this.incomebranshinvoice", this.incomebranshinvoice)
      this.cdr.detectChanges();
    });
  }

  getAllCycleCount() {
    this.gt.dropdown('CyclesStatiscs/AllCyclesStatiscsCount').subscribe((res: any) => {
      this.invoices = res;
      // console.log("this.invoices", this.invoices)
      this.cdr.detectChanges();
    });
  }

  getAllCycleCountQuery() {
    this.gt.dropdown('CyclesStatiscs/StoresCyclesStatiscsCountQuery').subscribe((res: any) => {
      this.storeStatics = res;
      // console.log("this.storeStatics", this.storeStatics)

      this.cdr.detectChanges();
    });
  }





  getMainMenuData() {
    this.sessiondata = sessionStorage.getItem("data");
    this.data = JSON.parse(this.sessiondata);
    this.data = this.data?.navihationMenu
    //make parent and child from data
    if (this.data) {
      this.data.forEach((ele: any) => {
        ele.children = []
        this.data.filter((filterele: any) => {
          ele.id == filterele.parentId ? ele.children.push(filterele) : ''
        })
      })
      //return basic list of data
      this.data = this.data.filter((res: { children: [], parentId: number }) => {
        return res.children.length > 0 && res.parentId != null
      })

      //filter data 
      this.data.forEach((ele: any) => {
        this.data = this.data.filter((res: any) => {
          return !ele.children.includes(res)
        })
      })
      this.loading = false
    }
  }

  navigate(data: chartobject) {
    if (data.filteration != null && data.filteration != undefined)
      this.gt.update("CyclesStatiscs/Update", { Filteration: data.filteration }).subscribe({ next: (res) => { } });
    if (data.xternalurl == null)
      return;
    const url = "/" + data.xternalurl
    this.gt.$Dateto.next(new Date().toISOString())
    this.gt.$Datefrom.next(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString());
    this.router.navigate([`${url}`])
  }
  navigatestore(data: chartobject) {
    this.router.navigate([`${data.xternalurl}`])

  }
  // getChildren(ele: { children: [], externalUrl: string, id: number, parentId: number }) {
  //   //
  //   this.selectedElement = ele;
  //   let Find: boolean = false
  //   let newparent = ele
  //   for (let index = 0; index < this.previousparent.length; index++) {
  //     if (ele.children.length > 0 && newparent.parentId == this.previousparent[index].parentId) {
  //       Find = true
  //       this.previous = index
  //       break
  //     }
  //   }
  //   if (Find) {
  //     this.previousparent.splice(this.previous, 1, ele);
  //     this.previousparent.length = this.previous + 1
  //   }

  //   else if (ele.children.length <= 0) {
  //     const targetRoute = ele.externalUrl;
  //     const baseUrl = window.location.origin; // Get base URL (e.g., http://localhost:4200)
  //     const fullUrl = `${baseUrl}/#/${targetRoute}`; // Combine base URL with route
  //     if (this.isnewtab == true) {
  //       // Open the route in a new tab
  //       window.open(fullUrl, '_blank');
  //     } else {
  //       this.router.navigate([`${ele.externalUrl}`])
  //     }


  //     this.gt.$HOMETAB.next(true)
  //   }

  //   else {
  //     this.previousparent = []
  //     this.data = []
  //     this.previousparent.push(ele)
  //   }
  //   this.gt.$home.next(this.previousparent)
  // }





























  GetTreeData() {
    let session: any = sessionStorage.getItem('data');
    if (session) {
      let parsed = JSON.parse(session);
      this.data = parsed.navihationMenu
      this.datanavgiation = parsed.navihationMenu.filter((ele: any) => ele.parentId == 1);
      this.previousparent = []
    }
  }



  GetChildren(parent: any) {
    if (parent.externalUrl !== "" && parent.externalUrl !== "tab") {
      this.router.navigate([`${parent.externalUrl}`]);
    }
    //tab

    if (this.data) {
      this.previousparent.push(parent);
      this.datanavgiation = this.data.filter(
        (child: any) => child.parentId === parent.id
      );
    }
  }



  back() {
    if (this.previousparent.length > 0) {
      this.previousparent.pop();
      if (this.previousparent.length > 0) {
        const parent = this.previousparent[this.previousparent.length - 1];
        this.datanavgiation = this.data.filter(
          (child: any) => child.parentId === parent.id
        );
      } else {
        this.datanavgiation = this.data.filter((ele: any) => ele.parentId === 1);
      }
    }
  }


  getBreadcrumb(): any[] {
    return this.previousparent.map((item: any) => item);
  }
  backToHome() {
    this.GetTreeData()
  }

  getIdBreadcrumb(item: any) {
    this.selectedBreadcrumb=item.id
    this.datanavgiation = this.data.filter(
      (child: any) => child.parentId === item.id
    );
  }

}